import {takeEvery} from 'redux-saga';
import {call, put} from 'redux-saga/effects';
import {appError, busy, ready} from './Status';
import {intersect} from '../lib/helpers';

const GET_TAGS = 'app-qa/tags/GET_TAGS';
export const getTags = (contextType, onlyBaseTags) => ({type: GET_TAGS, contextType, onlyBaseTags});

const CLEAR_TAGS = 'app-qa/tags/CLEAR_TAGS';
export const clearTags = () => ({type: CLEAR_TAGS});

const EXTRACT_TAGS = 'app-qa/tags/EXTRACT_TAGS';
export const extractTags = (contentType, content, suggestions) => ({type: EXTRACT_TAGS, contentType, content, suggestions});

const SET_LOADING_TAGS = 'app-qa/tags/SET_LOADING_TAGS';
export const setLoadingTags = (loading) => ({type: SET_LOADING_TAGS, loading});

const TAGS_REQUEST_SUCCESS = 'app-qa/tags/TAGS_REQUEST_SUCCESS';
export const tagsRequestSuccess = (tags) => ({type: TAGS_REQUEST_SUCCESS, tags});

export const actions = {
  GET_TAGS,
  CLEAR_TAGS,
  EXTRACT_TAGS,
  SET_LOADING_TAGS,
  TAGS_REQUEST_SUCCESS,
};

const initialState = {
  loadingTags: false,
  tags: [],
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case EXTRACT_TAGS: {
      const tags = intersect(action.content, action.suggestions.map((t) => t.tag));
      return action.contentType === 'title' ? {...state, titleTags: tags} : {...state, contentTags: tags};
    }
    case CLEAR_TAGS: {
      return {...state, titleTags: [], contentTags: []};
    }
    case SET_LOADING_TAGS: {
      return {...state, loadingTags: true};
    }
    case TAGS_REQUEST_SUCCESS: {
      return {...state, tags: action.tags.result, loadingTags: false};
    }
    default:
      return state;
  }
}

export function sagas({qaClient}) {
  function *getTagsSaga({contextType, onlyBaseTags}) {
    yield put(setLoadingTags(true));
    yield put(busy({blockUi: true}));
    try {
      const tags = yield call(() => qaClient.getTags(contextType, onlyBaseTags));
      yield put(tagsRequestSuccess(tags));
      yield put(ready());
    } catch (err) {
      yield put(appError({err}));
    }
  }

  return {
    *watchGetTags() { yield* takeEvery(GET_TAGS, getTagsSaga); },
  };
}
